"use client";

import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui/material";
import React from "react";
import { MOBILE_APPBAR_HEIGHT } from "#/features/appBar/constants";
import { useMobilePlaygroundView } from "../hooks/useMobilePlaygroundView";
import { MobileBrowseView } from "./MobileBrowseView";
import { MobileCodeView } from "./MobileCodeView";
import { MobilePhaseNavBar } from "./MobilePhaseNavBar";
import { MobileResultsView } from "./MobileResultsView";
const mainSx = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: "100%",
  height: "100%",
  transition: "opacity 0.1s ease-in-out"
} as const;
const hiddenSx = {
  opacity: 0,
  pointerEvents: "none"
} as const;
const visibleSx = {
  opacity: 1
} as const;
export const MobilePlayground: React.FC = () => {
  const $ = _c(23);
  const {
    currentView,
    goToResults
  } = useMobilePlaygroundView();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      position: "relative",
      height: `calc(100vh - ${MOBILE_APPBAR_HEIGHT}px - env(safe-area-inset-top, 0px))`,
      overflow: "hidden"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = currentView === "browse" ? visibleSx : hiddenSx;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      ...mainSx,
      ...t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MobileBrowseView />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Box id="browse-view" sx={t2}>{t3}</Box>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = currentView === "code" ? visibleSx : hiddenSx;
  let t6;
  if ($[6] !== t5) {
    t6 = {
      ...mainSx,
      ...t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== goToResults) {
    t7 = <MobileCodeView onRunComplete={goToResults} />;
    $[8] = goToResults;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <Box id="code-view" sx={t6}>{t7}</Box>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = currentView === "results" ? visibleSx : hiddenSx;
  let t10;
  if ($[13] !== t9) {
    t10 = {
      ...mainSx,
      ...t9
    };
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <MobileResultsView />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10) {
    t12 = <Box id="results-view" sx={t10}>{t11}</Box>;
    $[16] = t10;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <MobilePhaseNavBar />;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12 || $[20] !== t4 || $[21] !== t8) {
    t14 = <Box component="main" sx={t0}>{t4}{t8}{t12}{t13}</Box>;
    $[19] = t12;
    $[20] = t4;
    $[21] = t8;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  return t14;
};